/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 

import { connect } from "react-redux";
import { Divider, Dropdown, MenuProps } from "antd";
import { AccountCircleIcon, MoreIcon } from "../icons.component";
import { getLicenseFullName } from "src/utils/global";
import { CompanyDataProps } from "src/types/base.type";
import BaseInfo from "./group-info.component";

type CompanyCardProps = CompanyDataProps & {
  settings?: any;
  onChange?: (val:any) => void,
  onDelete?: (val:any) => void,
}
 
const CompanyCard = ({
  instanceId,
  alias,
  isFavorite,
  name,
  rfc,
  settings,
  onChange,
  onDelete,
} : CompanyCardProps) => {
  const itemsMenu: MenuProps['items'] = [
    {
      key: 'edit-company',
      label: (
        <a onClick={()=>onChange && onChange(instanceId)}>
          Editar
        </a>
      ),
    },
    {
      key: 'delete-company',
      label: (
        <a onClick={()=>onDelete && onDelete(instanceId)}>
          Mover a papelera
        </a>
      ),
    },
  ];
  return (
    <div className="app-card-company">
      <div className="app-card__container">
        <div className="app-card__info">
          <BaseInfo title={name} subtitle={rfc} excerpt={alias} avatarSrc="" />
          <Divider />
          <div className="app-card__row text secondary-color">
            <AccountCircleIcon size={16} />
            <span>{settings?.currentLicense ? getLicenseFullName(settings?.currentLicense) : ''}</span>
            <div><span className="app-dot"></span></div>
            <span>Propietario</span>
          </div>
        </div>
      </div>
      <div className="app-card__controls">
        <button className="btn-secondary">Acceder</button>
      </div>
      <div className="app-card__nav">
        <Dropdown menu={{items: itemsMenu}}>
          <button className="app-btn-icon"><MoreIcon /></button>
        </Dropdown>
      </div>
    </div>
  );
};

const mapStateToProps = (state:any) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CompanyCard);
